import api from "../../../api/cofocusAPI";

const loadInitialCalendarData = async function(UID, startDateMS, endDateMS) {
  return await api.getResponseData({
    method: "get",
    url: `/api/sessions/loadCalendar`,
    withCredentials: true,
    params: {
      UID,
      start: startDateMS,
      end: endDateMS,
      private: 1,
    },
  });
};

const getCurrentUserData = async function(currentUserID) {
  const response = await api.REQUEST({
    method: "get",
    url: `/api/users/${currentUserID}/matchingdata`,
    withCredentials: true,
    params: {
      private: 1,
    },
  });

  if (response && response.data && response.data.success) {
    return response.data.userData;
  }
  return null;
};

/**
 * @param {String} otherUserID the ID of the user whose public matchingdata is requested
 */
const getCalendarUserData = async function(otherUserID) {
  const response = await api.REQUEST({
    method: "get",
    url: `/api/users/${otherUserID}/matchingdata`,
    withCredentials: true,
    params: {
      private: 0,
    },
  });

  if (response && response.data && response.data.success) {
    return response.data.userData;
  }
  return null;
};

const getSessionsInRange = async function(userID, startDateMS, endDateMS) {
  const response = await api.REQUEST({
    method: "get",
    url: "/api/sessions",
    withCredentials: true,
    params: {
      UID: userID,
      start: startDateMS,
      end: endDateMS,
    },
  });
  if (!response || !response.data || !response.data.success) {
    throw new Error("Failed to fetch general sessions.");
  }
  return response.data;
};

async function getUserExcludedAndBlockedList(UID) {
  if (!UID) return null;
  return api.getResponseData({
    url: `api/users/${UID}/blockedExcludedList`,
    method: "get",
    params: { UID },
    withCredentials: true,
  });
}

export default {
  loadInitialCalendarData,
  getCurrentUserData,
  getCalendarUserData,
  getSessionsInRange,
  getUserExcludedAndBlockedList,
};
